import api from './api'

export const getPlans = async () => await api.get('/plans/')

export const myPlan = async id => api.get(`/saas/${id}/get_plan/`)

export const getInvoices = async id => api.post(`/saas/${id}/get_invoices/`)

export const suspendSubscription = async (user_id, cancel_motivation) =>
  await api.post(`/professional/${user_id}/suspend_subscription/`, {
    cancel_motivation
  })

export const activateSubscription = async user_id =>
  await api.post(`/professional/${user_id}/activate_subscription/`)

export const cancelMonthplanPrepaidEndpoint = (uid, token, monthplan_id, reason) =>
  api.post(`/cancel_monthplan_prepaid/${uid}/${token}/`, {
    monthplan_id: monthplan_id,
    reason: reason
  })
